import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { statLabels } from '@sorare/core/src/lib/scoring';

import { TutorialBezel } from '../../TutorialBezel';
import { Stat } from '../Stat';

const Root = styled(Horizontal)`
  height: 100%;
  padding: var(--quadruple-unit);
`;

export const Milestones = () => {
  return (
    <TutorialBezel color="var(--c-green-400)">
      <Root gap={4} center>
        <Stat
          color="var(--c-green-400)"
          value={1}
          label={<FormattedMessage {...statLabels.double_double} />}
        />
        <Stat
          color="var(--c-green-400)"
          value={1}
          label={<FormattedMessage {...statLabels.triple_double} />}
        />
      </Root>
    </TutorialBezel>
  );
};
